import React from 'react'
import Typography, { TypographyProps } from '@material-ui/core/Typography'

interface ISubtitle1Prop {
  children: string
}
// default body text
export const Subtitle1 = ({
  children,
  ...props
}: TypographyProps & ISubtitle1Prop) => (
  <Typography variant="subtitle1" {...props}>
    {children}
  </Typography>
)
